import { render, staticRenderFns } from "./WorkflowReports.vue?vue&type=template&id=27650e7a"
import script from "./WorkflowReports.vue?vue&type=script&lang=js"
export * from "./WorkflowReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports